// Integration related types & enums (mirrors backend enums / DTOs)
export var IntegrationProvider;
(function (IntegrationProvider) {
    IntegrationProvider["Salesforce"] = "Salesforce";
    IntegrationProvider["HubSpot"] = "HubSpot";
    IntegrationProvider["BigMarker"] = "BigMarker";
    IntegrationProvider["Formcarry"] = "Formcarry";
})(IntegrationProvider || (IntegrationProvider = {}));
export var IntegrationConnectionStatus;
(function (IntegrationConnectionStatus) {
    IntegrationConnectionStatus["PendingAuthorization"] = "PendingAuthorization";
    IntegrationConnectionStatus["Active"] = "Active";
    IntegrationConnectionStatus["Disabled"] = "Disabled";
    IntegrationConnectionStatus["Error"] = "Error";
    IntegrationConnectionStatus["AuthExpired"] = "AuthExpired";
})(IntegrationConnectionStatus || (IntegrationConnectionStatus = {}));
export var IntegrationAuthType;
(function (IntegrationAuthType) {
    IntegrationAuthType["ApiKey"] = "ApiKey";
    //   ApiKeyPair = 'ApiKeyPair',
    //   Hmac = 'Hmac',
    //   OAuthAuthorizationCode = 'OAuthAuthorizationCode',
    //   OAuthClientCredentials = 'OAuthClientCredentials',
    //   None = 'None',
})(IntegrationAuthType || (IntegrationAuthType = {}));
export const INTEGRATION_STATUS_COLORS = {
    PendingAuthorization: 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300',
    Active: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300',
    Disabled: 'bg-slate-200 text-slate-700 dark:bg-slate-700 dark:text-slate-200',
    Error: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300',
    AuthExpired: 'bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-300',
};
export const INTEGRATION_AUTH_LABELS = {
    ApiKey: 'API Key',
    //   ApiKeyPair: 'API Key + Secret',
    //   Hmac: 'HMAC',
    //   OAuthAuthorizationCode: 'OAuth (Auth Code)',
    //   OAuthClientCredentials: 'OAuth (Client Creds)',
};
export const INTEGRATION_PROVIDER_LABELS = {
    Salesforce: 'Salesforce',
    HubSpot: 'HubSpot',
    BigMarker: 'BigMarker',
    // Canonical enum key
    FormCarry: 'Formcarry',
    // Fallback for legacy / inconsistent casing that may appear in persisted data
    Formcarry: 'Formcarry',
};
